import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/assets/images/g3.webp")